import React from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'; // Necesario react-icons de la navbar

// Importamos los estilos base de la librería (OBLIGATORIOS)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HeroCarousel.css'; // Nuestros estilos personalizados

// Importamos tus imágenes (asegurate de que las rutas sean correctas)
import imgCampo from '../assets/ver_productos.jpg';
import imgQuienes from '../assets/quienes_somos.jpg';
import imgProduccion from '../assets/como_producimos.jpg';

// Definimos los datos de cada diapositiva (slide)
const slidesData = [
  {
    id: 1,
    imagen: imgCampo,
    titulo: 'Páscolo: Quesos de Tambo Propios',
    subtitulo: 'Productos naturales, sin aditivos',
    botonTexto: 'Ver Productos',
    link: '/productos'
  },
  {
    id: 2,
    imagen: imgQuienes,
    titulo: 'Nuestra Historia',
    subtitulo: 'Conocé quiénes somos y por qué elegimos la elaboración artesanal.',
    botonTexto: 'Quiénes Somos',
    link: '/quienes-somos'
  },
  {
    id: 3,
    imagen: imgProduccion,
    titulo: 'Así Elaboramos Nuestros Productos',
    subtitulo: 'Un recorrido por nuestro proceso, desde el ordeñe hasta la maduración.',
    botonTexto: 'Cómo Producimos',
    link: '/como-producimos'
  }
];

// Componentes para las flechas personalizadas (opcional, para mejor diseño)
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next" onClick={onClick}><FaChevronRight /></div>
);
const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev" onClick={onClick}><FaChevronLeft /></div>
);

const HeroCarousel = () => {
  // Configuración del carrusel
  const settings = {
    dots: true,               // Muestra los puntitos abajo
    infinite: true,           // Bucle infinito
    speed: 600,               // Velocidad de transición (suave)
    slidesToShow: 1,          // Muestra una foto a la vez
    slidesToScroll: 1,
    autoplay: true,           // Se mueve solo
    autoplaySpeed: 5000,      // Cambia cada 5 segundos
    pauseOnHover: true,       // Para si pasás el mouse encima
    nextArrow: <NextArrow />, // Flecha derecha personalizada
    prevArrow: <PrevArrow />, // Flecha izquierda personalizada
    appendDots: dots => <div className="slick-dots-container"><ul>{dots}</ul></div>, // Para estilizar los puntitos
  };

  return (
    <div className="hero-carousel-container">
      <Slider {...settings}>
        {slidesData.map((slide) => (
          <div key={slide.id} className="slick-slide-item">
            {/* Imagen de fondo */}
            <img src={slide.imagen} alt={slide.titulo} className="slide-image" />
            
            {/* Capa oscura superpuesta (overlay) para que el texto blanco sea legible, igual que tus imágenes de ejemplo */}
            <div className="slide-overlay"></div>
            
            {/* Contenido de texto y botón encima */}
            <div className="slide-content">
              <h1>{slide.titulo}</h1>
              <p>{slide.subtitulo}</p>
              <Link to={slide.link} className="slide-btn">
                {slide.botonTexto}
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroCarousel;